"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateSet = void 0;
const dateParse_1 = require("./dateParse");
const dateTimeFormat_1 = require("./dateTimeFormat");
/**
 * dodaje określoną liczbę jednostek do daty
 * @param date data wejściowa
 * @param part częśc daty do zmiany
 * @param value o lie zwiększyć
 */
function dateSet(date, part, value) {
    const inputDate = (0, dateParse_1.dateParse)(date);
    const result = new Date(inputDate);
    switch (part) {
        case 'y':
        case 'yy':
        case 'yyyy':
        case 'year':
            result.setFullYear(value);
            break;
        case 'M':
        case 'MM':
        case 'month':
            result.setMonth(value + 1);
            break;
        case 'd':
        case 'dd':
        case 'day':
            result.setDate(value);
            break;
        case 'h':
        case 'hh':
        case 'hour':
            result.setHours(value);
            break;
        case 'm':
        case 'mm':
        case 'minute':
            result.setMinutes(value);
            break;
        case 's':
        case 'ss':
        case 'second':
            result.setSeconds(value);
            break;
    }
    if (date.length === 10) {
        return (0, dateTimeFormat_1.dateTimeFormat)(result).replace(' 00:00:00', '');
    }
    else {
        return (0, dateTimeFormat_1.dateTimeFormat)(result);
    }
}
exports.dateSet = dateSet;
//# sourceMappingURL=dateSet.js.map